<template>
  <g>
    <path
      class="st0"
      d="M957.7,423.84c-4.98-26.93-62.55-9.73-64.87-14.91c-2.32-5.18,33.52-5.41,27.58-24.22
			c-3.61-11.42-36.29-6.52-50.49-4.2c-14.2,2.32-17.86,10.81-27.35-11.88c-19.75-32.06-36.08-21.89-43-1.66
			c-1.88,5.51-6.76,9.33-12.58,9.37c-8.96,0.07-18.06,0.25-27.25,0.52c-5.89,0.17-11.24-3.5-13.14-9.08
				c-24.4-71.96-50.59-139.54-72.01-172.31c-64.31-92.81-223.67-98.53-283.43,25.63c-27.2,43.24-48.05,117.68-63.65,195.56
				c-1.16,5.77-5.98,10.17-11.83,10.75c-3.08,0.31-5.83,0.54-8.22,0.69c-3.59,0.22-7.05-1.04-9.71-3.46
				c-14.92-13.55-26.42-24.93-41.19-15.74c-12.95,8.06-1.48,25.99-6.05,30.26c-5,4.11-12.94,5.47-34.55,5.83
				c-21.62,0.36-37.92-0.27-35.55,23.4c1.16,11.65,22.42,7.68,23.49,18.4c1.07,10.72-17.06,9.83-13.87,23.68
				c3.19,13.86,31.74,10.62,32.34,16.63c0.6,6.01-23.29,10.69-21.41,20.43c1.88,9.74,2.5,15.99,42.61,11.08
				c13.66-2.43,28.63-4.65,44.59-6.7c8.75-1.12,16.25,6.27,15.12,15.01c-10.46,80.81-14.89,142.16-14.89,142.16
				c-5.14,72.73-46.92,112.73-71.57,118.8c-23.98,5.91-39.84,39.17-8.35,56.32c2.48,1.35,38.67,8.84,41.49,8.93
				c41.18,1.3,193.87-14.55,257.66-30.72c22.03-5.59,26.87-10.91,27.21-33.64c1.2-79.27-21.64-219.84,14.96-221.8
				c31.61-1.69,53.31,212.26,65.79,290.67c3.3,20.7,16.29,25.55,37.24,26.18c75.25,2.25,250.98-9.64,274.76-14.52
				c21.55-4.42,34.25-9.39,37.01-16.02c11.58-27.8-28.62-40.15-55.67-47.39c-31.29-8.37-80.43-201.13-85.91-224.1
				c-1.59-6.65-9.19-34.97-20.54-74.36c-2.49-8.64,4.09-17.32,13.08-17.22c25.1,0.29,40.55,0.78,42.41,1.25
				c10.18,2.59,36.8,16.17,47.79-0.27c10.99-16.44-19.74-16.97-14.16-28.36c5.58-11.38,53.82,9.96,54.81-16.3
				c0.98-26.26-43.32-18.22-43.35-27.49C903.01,449.79,963.1,453.05,957.7,423.84z M603.21,264.48c29.77-4.33,45.47,26.49,32.41,30.75
				c-16.56,5.4-6.49-17.21-31.62-11.72c-20.97,4.58-10.94,19.14-24.99,23.02C565.11,310.37,573.42,268.81,603.21,264.48z 
				M454.74,279.48c30.07-0.53,40.45,36.87,26.79,38.24c-16.04,1.6-1.82-18.63-27.55-18.77c-25.73-0.14-16.64,20.83-31.06,20.92
				C408.49,319.97,424.4,280.01,454.74,279.48z"
    />
    <path
      class="st0"
      d="M1378.83,810.97c-7.19-10.82-18.36-40.26-12.12-50.61c6.37-10.55,21.16-13.34,31.73-13.55
				c64.88-1.31,201.85,33.51,229.33,45.71c13.97,6.2,42.93,16.63,53.57-2.46c11.38-20.38-21.13-32.32-16.74-38.69
				c2.18-3.17,48.81,9.17,56.63-8.73c11.81-27.02-39.1-34.77-22.94-56.66c0.65-5.66,49.39,0.4,50.57-27.13
				c1.18-21.62-38.7-29.15-37.53-39.25c1.17-10.09,51.71,0.18,47.47-34.18c-3.4-27.63-64.53-27.5-87.17-28.42
				c-22.64-0.91-25.36-9.66-30.58-13.68c-4.76-4.15,43.72-54.74-0.45-69.01c-17.03-5.5-38.59,20.81-54.91,32.36
				c-69.55,49.21-413.37,155.71-548.65,43.78c-3.68-3.05-11.7-10.9-16.83-33.67c-4.53-20.06-10.77-43.81-29.23-12.55
				c-6.79,11.5-8.56,15.96-17.19,15.93c-15.09-0.05-45.44-14.04-49.27-3.35c-6.3,17.59,12.57,27.37,6.6,35.3
				c-9.73,12.93-36.3,1.33-39.24,11.75c-4.95,17.5,23.93,21.51,19.62,29.19c-4.28,7.63-32.41,0.54-27.8,24.94
				c2.88,15.25,26.92,5.69,32.72,16.59c5.8,10.9-18.04,19.57-2.85,31.81c6.79,5.47,41.04-1.05,51.92-0.46
				c61.82,3.32,205.32,27.19,254.08,96.84c21.45,30.63,29.39,64.44,29.39,64.44c23.72,129.53,25.82,171.04-41.69,219.96
				c-89.72,65.01-202.45-45.01-203.98-51.93c-1.19-5.37,1.14-10.51,3.44-15.61c3.83-8.47,8.06-11.21,8.07-18.17
				c0,0,0.01-2.95-0.96-5.77c-4.89-14.22-118.57-13.8-167.26-9.24c-86.78,8.13-189.07,21.93-191.06,37.58
				c-0.58,4.54,5.38,5.62,18.09,27.53c3.38,5.82,8.81,15.83,10.36,29.47c0.06,0.57,0.1,0.98,0.11,1.02
				c65.33,336.38,489.9,360.02,617.6,278.79C1568.65,1151.01,1394.79,835,1378.83,810.97z"
    />
    <path
      class="st0"
      d="M1180.31,458.68c11.65,0.44,15.13,9.77,16.77,37.73c2.19,37.23-4.48,42.42-12.25,42.12
					c-8.59-0.33-18.26-6.04-19.61-43.76C1164.22,466.87,1170.68,458.31,1180.31,458.68z"
    />
    <path
      class="st0"
      d="M1253.26,438.63c14.58,0.56,18.93,12.23,20.98,47.21c2.74,46.57-5.61,53.07-15.33,52.7
			c-10.74-0.41-22.84-7.56-24.53-54.75C1233.13,448.88,1241.23,438.17,1253.26,438.63z"
    />
  </g>
</template>

<script>
export default {};
</script>

<style scoped>
path {
  font-family: var(--iconFontFamily);
  font-size: var(--iconFontSize);
  fill: var(--iconTextColor);
  stroke: var(--iconBorderColor);
}
.nav-item svg:hover path {
  fill: var(--color-hover);
}
</style>